import Check from '../Check';
import Report from '../Report';
import { MessageType } from '../Message';
import type { IMethod } from '../../../stores/model/metamodel/method';

class InheritedCreateMethodCheck extends Check<IMethod> {
  static description = 'Check non-specialised I/C Method';

  check(): Report {
    this.report = new Report();

    const method = this.element;
    if (method.provenance === 'INHERITED' && method.type === 'CREATE' && !method.specialised) {
      this.report.addMessage(
        MessageType.WARNING,
        'I/C Method should be specialised',
        this,
        this.element
      );
    }

    return this.report;
  }
}

export default InheritedCreateMethodCheck;
